module.exports = __webpack_public_path__ + "media/images/emblems/Niederbuchsiten-blason-f6f27bf5fd6fb1d16f0631aaa3dd333c.png";